export default function AccountResetPasswordController(
    $scope,
    Users,
    $routeParams,
    siteService
) {
    const uid = $routeParams.uid;

    $scope.uid = uid;

    $scope.formHolder = {};

    $scope.siteService = siteService;

    const verifyUid = (uid) => {
        Users.verifyUid(uid).then(
            (res) => {
                // API return 200
                $scope.uidVerified = true;
            },
            (err) => {
                // expired ok
                // uid not found
                $scope.uidVerified = false;
            }
        );
        // return uid === acceptedUID ? $q.resolve(uid) : $q.reject(uid);
    };

    verifyUid(uid);

    siteService.getPage(94).then(function (result) {
        // if user is allready logged in
        if (result.articleItems[0]) {
            // bool
            $scope.sidebarContent = result.articleItems[0].articleSections[0];
        }
    });
}
